import { Button } from '@material-ui/core'
import axios from 'axios'
import React from 'react'
import { useRecoilState } from 'recoil'
import { accountsState } from '../recoil/atoms'

const ConfirmAccountDelete = props => {
    const [accounts, setAccounts] = useRecoilState(accountsState)
    const deleteHandler = () => {
        axios({
            url: 'accounts/account/',
            method: "delete",
            data: {
                id: props.id
            }
        }).then(() => {
            setAccounts(accounts.filter(account => account.id !== props.id))
            props.setPopup(false)
        })
    }

    return (
        <>
            <Button
                type="submit"
                variant="contained"
                color="secondary"
                style={{ margin: 10 }}
                onClick={deleteHandler}
            >
                بله
                </Button>
            <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ margin: 10 }}
                onClick={() => props.setPopup(false)}
            >
                خیر
            </Button>
        </>
    )
}

export default ConfirmAccountDelete
